'use client';
'use strict';

var dayjs = require('dayjs');

function isYearDisabled(year, minDate, maxDate) {
  if (!minDate && !maxDate) {
    return false;
  }
  if (minDate && dayjs(year).isBefore(minDate, "year")) {
    return true;
  }
  if (maxDate && dayjs(year).isAfter(maxDate, "year")) {
    return true;
  }
  return false;
}

exports.isYearDisabled = isYearDisabled;
//# sourceMappingURL=is-year-disabled.cjs.map
